import { render, staticRenderFns } from "./lib-template.vue?vue&type=template&id=12d50500&scoped=true"
import script from "./lib-template.vue?vue&type=script&lang=js"
export * from "./lib-template.vue?vue&type=script&lang=js"
import style0 from "./lib-template.vue?vue&type=style&index=0&id=12d50500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d50500",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonNewHeaderOut: require('/builds/wj/fe/wenjuan-homesite/components/common/new-header-out.vue').default,CommonDevModeWrap: require('/builds/wj/fe/wenjuan-homesite/components/common/dev-mode-wrap.vue').default})
